import { set } from 'lodash-es';

export default (args: any[], state: any) => {
  const [fieldName, modifiedSinceLastBlur] = args;
  if (!(state.fields && state.fields[fieldName] && state.fields[fieldName].data)) return;

  set(state.fields[fieldName].data, 'modifiedSinceLastBlur', modifiedSinceLastBlur);
};
